import { Field } from 'formik';
import formikMetaToState from '../../helpers/formikMetaToState';
import { DropdownSearch, DropdownSearchProps } from '../DropdownSearch';

export const FormikDropdownSearch = (props: DropdownSearchProps & { name: string }) => {
  const { name } = props;

  return (
    <Field name={name}>
      {({ field, meta, form }: any) => {
        const { error, state } = formikMetaToState(meta);
        // Fix defects in SelectSearch,
        // onBlur does not produce the value, it is required for Formik
        // onChange has a non standard argument that is not supported by Formik
        return (
          <DropdownSearch
            {...field}
            {...props}
            error={error}
            state={state}
            onChange={(v) => {
              form.setFieldValue(field.name, v, true /*validate*/);
            }}
            onBlur={() => {
              form.setFieldTouched(
                field.name,
                true /* set touched=true */,
                false /* do not validate, validation is set onChange */,
              );
            }}
          />
        );
      }}
    </Field>
  );
};
